module.exports = __webpack_public_path__ + "67834b2e6d5b245e0d6cfa570c6c028e.woff";